<template>
    <div class="pb-5">
        <default-layout :lbl="lbl"
                        :locale="locale"
                        :isLogin="isLogin"
                        :profile="profile"
                        :campaign="campaign"
                        v-if="isLoaded"></default-layout>
                         
        <modal view="register-main" :busModal="busModal"></modal>
    </div>
    
</template>
<script>

import Vue from "vue";
import Account from "@/helper/AccountHelper.js";
import BzbsCampaign from "@/service/BzbsCampaign.js";
import Locale from '@/helper/locale/locale.js';

import DefaultLayout from "@/components/campaign/layout/Default.vue";
import {
    CampaignConfigBuilder
} from "@/service/config/CampaignConfigModel.js";

import Modal from "@/components/modal/Modal.vue";

export default {
    name: "Campaign",
    components: {
        DefaultLayout,
        Modal,
    },
    data: function() {
        return {
            isLogin: false,
            user: {},
            profile: {},
            lbl: Locale.getLbl(),
            locale: Locale.getLocaleCode(),

            isLoaded: false,
            campaignId: '',
            campaign: null,
            campaignConfig: null,

            busModal: new Vue(),
        };
    },
    created: function() {
        Account.loginStatus().then((status) => {
            this.isLogin = status;
            this.user = Account.getCacheUser();
            this.profile = Account.getCacheProfile();
        });

    },
    mounted: function () {
        
        this.initialConfig();
        this.getCampaign();
       
    },
    methods: {
        initialConfig: function () {
            this.campaignId = this.$route.params.campaignId;
            this.campaignConfig = new CampaignConfigBuilder()
                .setCampaignId(this.campaignId)
                .create();
        },
        getCampaign: function() {
            this.showLoading();
            var strBzbsToken = Account.getToken();
            BzbsCampaign.apiGetCampaignDetail(strBzbsToken, this.campaignConfig).then((result) => {
                this.campaign = result;
                this.isLoaded = true;
                this.hideLoading();
            }).catch((error) => {
                this.hideLoading();
                 if (error.response) {
                     console.log(error);
                } else {
                    console.log(error);
                    this.showErrorConnectModal();
                    // this.isInternetConnected = false;
                }
            });
        },
        toggleLoading: function (isLoading) {
            this.isLoading = isLoading;
        },
        switchLang: function(locale) {
            Locale.setLocale(locale);
            this.lbl = Locale.getLbl();
        },
        logout: function() {
            Account.setLogout();
            this.isLogin = false;
            this.profile = {};
        },
        showLoading: function() {
            this.busModal.$emit('showLoadingModal', {});
        },
        hideLoading: function() {
            this.busModal.$emit('hideLoadingModal', {});
        },
        showErrorConnectModal: function() {

            var configModal = {
              
                message: this.lbl.error_connect.message,
                strBtnOk: this.lbl.error_connect.btn_close,
            };
            this.busModal.$emit('showErrorConnectModal', configModal);
        },

    },
}
</script>
<style lang="scss">
    @import "@/style/page/campaigndetail.scss";
</style>

